import { render } from "./Blogs.vue?vue&type=template&id=c16ddb60"
import script from "./Blogs.vue?vue&type=script&lang=ts"
export * from "./Blogs.vue?vue&type=script&lang=ts"
script.render = render

export default script